var render, staticRenderFns
import script from "./ElScrollbar.vue?vue&type=script&lang=js"
export * from "./ElScrollbar.vue?vue&type=script&lang=js"
import style0 from "./ElScrollbar.vue?vue&type=style&index=0&id=77a99c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports